import clsx from 'clsx'

import { Button } from 'shared/ui/button'

import styles from './styles.module.scss'

type Props = {
  onClick: () => void
  text: string
}

export const RenderButton = ({ onClick, text }: Props) => {
  return (
    <div className={styles.buttonWrapper}>
      <div className={styles.button}>
        <Button onClick={onClick}>
          <span className={clsx('bold-16', styles.text)}>{text}</span>
        </Button>
      </div>
    </div>
  )
}
